module.exports = __webpack_public_path__ + "static/media/checkGreen.7936572b.svg";